import './Banner.scss';
import Nav from '../Nav';

export default function Banner() { 
    return (
      <header> 
        <Nav></Nav>  
      </header> 
    );
} 
 